export function filterChannels(authUser, channels, isAdmin) {
    if (!authUser) {
        return [];
    }

    return channels.filter(channel => {
        if (isAdmin) {
            return true;
        }
        if (authUser.isOwner || authUser.isSuperAdmin || (authUser.role && authUser.role.isRoot)) {
            return true;
        }

        const { users, departments } = channel.visibility;

        if (users.length === 0 && departments.length === 0) {
            return true;
        }

        if (users.length > 0 && users.includes(authUser._id)) {
            return true;
        }

        if (departments.length > 0 && authUser.department && departments.includes(authUser.department)) {
            return true;
        }

        if (departments.some(department => department.subjects && department.subjects.includes(authUser._id))) {
            return true;
        }

        if (authUser.subjects && authUser.subjects.some(subject => departments.includes(subject))) {
            return true;
        }

        return false;
    });
}
